/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import Bluebird from 'bluebird';
import _ from 'underscore';

import { Analytics } from '@trello/atlassian-analytics';
import {
  isDesktop as _isDesktop,
  isEmbeddedInAtlassian,
} from '@trello/browser';
import { isWorkspaceReadOnly } from '@trello/business-logic/organization';
import { ComponentWrapper, renderReactRoot } from '@trello/component-wrapper';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { forTemplate } from '@trello/legacy-i18n';
import { usesEnglish } from '@trello/locale';
import { navigate } from '@trello/router/navigate';
import { TrelloStorage } from '@trello/storage';
import { getOrganizationAccountUrl } from '@trello/urls';

import { getBoardUrl } from 'app/scripts/controller/urls';
import { Auth } from 'app/scripts/db/Auth';
import { ModelLoader } from 'app/scripts/db/model-loader';
import { ModelCache } from 'app/scripts/db/ModelCache';
import { l } from 'app/scripts/lib/localize';
import type { Organization } from 'app/scripts/models/Organization';
import { getPermLevelIconClass } from 'app/scripts/views/internal/BoardDisplayHelpers';
import { templates } from 'app/scripts/views/internal/templates';
import { View } from 'app/scripts/views/internal/View';
import { Alerts } from 'app/scripts/views/lib/Alerts';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { BoardCopyTemplate } from 'app/scripts/views/templates/BoardCopyTemplate';
import { BoardCopyVisTemplate } from 'app/scripts/views/templates/BoardCopyVisTemplate';
import { BoardMenuVisTemplate } from 'app/scripts/views/templates/BoardMenuVisTemplate';
import { BoardWouldPushWorkspaceOverLimit } from 'app/src/components/BoardWouldPushWorkspaceOverLimit';
import { cachedInboxIdsState } from 'app/src/components/Inbox/cachedInboxIdsState';
import { CreateBoardPopoverButton } from 'app/src/components/UpgradePathAudit';
import lastOrganization from 'app/src/last-organization';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

// eslint-disable-next-line @trello/no-module-logic
const LastOrganization = lastOrganization(TrelloStorage);

const format = forTemplate('board_copy');
// eslint-disable-next-line @trello/no-module-logic
const isDesktop = _isDesktop();

interface CopyBoardView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _onBoardNameChangeDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  boardNameInputValue: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  gasSource: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loading: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: any;
  unmountReadonlyWorkspaceUpsell?: () => void;
}

class CopyBoardView extends View {
  static initClass() {
    this.prototype.events = {
      // @ts-expect-error TS(2322): Type '{ 'change select[name="org-id"]': string; 'c... Remove this comment to see the full error message
      'change select[name="org-id"]': 'changeOrg',
      'submit form': 'submit',
      'input input[id="boardNewTitle"]': 'onBoardNameChangeDebounced',
      'click .js-submit': 'submit',
      'click .js-change-vis': 'openChangeVis',
      'click .js-select': 'selectVis',
      'click .js-confirm-public': 'confirmPublic',
      'click .js-cancel-public': 'cancelPublic',
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(options: any) {
    super(options);
    this.getViewTitle = this.getViewTitle.bind(this);
    this._onBoardNameChangeDebounced = _.debounce(this.onBoardNameChange, 400);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialize({ boardNameInputValue, gasSource }: any) {
    this.boardNameInputValue = boardNameInputValue;
    this.gasSource = gasSource;
  }

  getData() {
    this.loading = true;
    return ModelLoader.loadBoardMinimal(this.model.get('id')).finally(() => {
      this.loading = false;
      // Send screen event only when the popover has finished loading
      Analytics.sendScreenEvent({
        name: 'copyBoardInlineDialog',
        containers: {
          board: {
            id: this.model.id,
          },
          organization: {
            id: this.model.getOrganization()?.id,
          },
        },
        attributes: {
          isTemplate: this.model.isTemplate(),
        },
      });
      return this.render();
    });
  }

  getViewTitle() {
    if (this.model.isTemplate()) {
      return l(['view title', 'create board from template']);
    }

    return l(['view title', 'copy board']);
  }

  getOrganization() {
    switch (this.model.typeName) {
      case 'Organization':
        return this.model;
      case 'Board':
        return this.model.getOrganization();
      case 'Member':
        return null;
      default:
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getDefaultIdOrganization(idOrgs: any) {
    let id, idOrganization;
    if (idOrgs.length === 0) {
      return null;
    }

    if (this.options.useLastOrganization) {
      if (idOrgs.length === 1) {
        return idOrgs[0];
      }

      const idLastOrganization = LastOrganization.get();
      if (idLastOrganization === LastOrganization.NO_ORGANIZATION) {
        return null;
      } else if (
        idLastOrganization != null &&
        Array.from(idOrgs).includes(idLastOrganization)
      ) {
        return idLastOrganization;
      } else {
        // Use the most recently created org
        idOrganization = null;
        for (id of Array.from(idOrgs)) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          if (idOrganization == null || id > idOrganization) {
            idOrganization = id;
          }
        }
        return idOrganization;
      }
    } else {
      if ((idOrganization = this.getOrganization()?.id) != null) {
        return idOrganization;
      } else {
        const bestOrgId = Auth.me().getBestOrganization()?.id;
        if (bestOrgId != null) {
          return bestOrgId;
        } else {
          return null;
        }
      }
    }
  }

  render() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let boardEnterprise: any;
    const me = Auth.me();

    const idOrganization = this.getDefaultIdOrganization(
      // @ts-expect-error TS(2339): Property 'pluck' does not exist on type 'Organizat... Remove this comment to see the full error message
      me.organizationList.pluck('id'),
    );

    let orgs = me.organizationList;

    const isPublicTemplate =
      this.model.get('prefs').isTemplate &&
      this.model.get('prefs').permissionLevel === 'public';
    const boardHasEnterprise = this.model.get('enterpriseOwned');
    const isPaidManagedEntMember = me.isPaidManagedEntMember();

    // restrict the dropdown to enterprise teams for managed enterprise members
    if (isPaidManagedEntMember) {
      orgs = orgs.filter((org) => org.belongsToRealEnterprise());
    }

    const personalWorkspaceId =
      cachedInboxIdsState.value[me.id]?.idOrganization;
    if (personalWorkspaceId) {
      orgs = orgs.filter((org) => org.id !== personalWorkspaceId);
    }

    if (boardHasEnterprise && !isPublicTemplate) {
      // We may or may not know anything about the board's enterprise. If we do, restrict copies
      // to that board's enterprise. The one exception is a public template.
      // If the user is associated with multiple enterprises, it's possible they
      // could select the wrong one, but at least the server will enforce the content
      // restrictions
      boardEnterprise = this.model.getEnterprise();
      if (boardEnterprise) {
        orgs = orgs.filter(
          (org) => org.get('idEnterprise') === boardEnterprise.get('id'),
        );
      } else {
        orgs = orgs.filter((org) => org.get('idEnterprise'));
      }
    }

    // @ts-expect-error TS(2322): Type '{ selectOrg: boolean; id?: string | undefine... Remove this comment to see the full error message
    orgs = orgs.map((org) => ({
      ...org.toJSON(),
      selectOrg: org.id === idOrganization,
    }));

    // We'll only show the "(none)" option for enterprise boards if they're explicitly
    // owned by an enterprise, i.e. if their `idEnterprise` field is set. When that field is set we know
    // that the board will retain the enterprise owneship status when moved to a user's "private space".
    const showPrivateBoardsOptionForEntBoards =
      this.model.get('idEnterprise') != null;

    const data = {
      orgs,
      canAddToOrgs: orgs.length !== 0,
      isDesktop,
      loading: this.loading,
      boardHasEnterprise,
      showPrivateBoardsOptionForEntBoards,
    };
    if (boardEnterprise) {
      // @ts-expect-error TS(2339): Property 'enterpriseName' does not exist on type '... Remove this comment to see the full error message
      data.enterpriseName = boardEnterprise.get('displayName');
    }
    // Yes, this is implicit coupling to the number of placeholders
    // we have in the strings file. If we ever have another nondeterministic
    // string, we can think about doing this more formally...
    const placeholderKey = Math.floor(Math.random() * 13).toString();
    // @ts-expect-error TS(2339): Property 'placeholder' does not exist on type '{ o... Remove this comment to see the full error message
    data.placeholder = l(['board name placeholder', placeholderKey]);

    // @ts-expect-error TS(2339): Property 'publicConfirmationText' does not exist o... Remove this comment to see the full error message
    data.publicConfirmationText = l([
      'confirm',
      'public board confirmation',
      'text',
    ]);
    // @ts-expect-error TS(2339): Property 'publicConfirmationConfirm' does not exis... Remove this comment to see the full error message
    data.publicConfirmationConfirm = l([
      'confirm',
      'public board confirmation',
      'confirm',
    ]);
    // @ts-expect-error TS(2339): Property 'publicConfirmationCancel' does not exist... Remove this comment to see the full error message
    data.publicConfirmationCancel = l(['cancel']);
    // @ts-expect-error TS(2339): Property 'isTemplate' does not exist on type '{ or... Remove this comment to see the full error message
    data.isTemplate = this.model.isTemplate();

    if (this.boardNameInputValue) {
      // @ts-expect-error TS(2339): Property 'boardNameInputValue' does not exist on t... Remove this comment to see the full error message
      data.boardNameInputValue = this.boardNameInputValue;
    }

    // @ts-expect-error TS(2339): Property 'pLevel' does not exist on type '{ orgs: ... Remove this comment to see the full error message
    data.pLevel = 'private';
    if (this.model.owned()) {
      // @ts-expect-error TS(2339): Property 'pLevel' does not exist on type '{ orgs: ... Remove this comment to see the full error message
      data.pLevel = this.model.get('prefs').permissionLevel;
    } else if (idOrganization != null) {
      // @ts-expect-error TS(2339): Property 'pLevel' does not exist on type '{ orgs: ... Remove this comment to see the full error message
      data.pLevel = 'org';
    }

    if (this.options != null ? this.options.newOrgBoard : undefined) {
      // @ts-expect-error TS(2339): Property 'hideOrg' does not exist on type '{ orgs:... Remove this comment to see the full error message
      data.hideOrg = true;
    }

    this.$el.html(templates.fill(BoardCopyTemplate, data));

    this.checkBoardPermissions();

    return this;
  }

  checkBoardPermissions() {
    const orgId = $('select[name="org-id"]', this.$el).val();
    if (!orgId) {
      this.renderBoardVisChooser();
      return;
    }

    return this.loadOrg(orgId).then((org) => {
      // Show the board limits CTA
      if (org?.isAtOrOverFreeBoardLimit()) {
        $('.js-board-limits-upgrade-ad', this.$el).removeClass('hide');
        $('.js-target-team', this.$el).text(org.get('displayName'));
        $('.js-upgrade-link', this.$el).attr(
          'href',
          // @ts-expect-error TS(2345): Argument of type 'void' is not assignable to param... Remove this comment to see the full error message
          this.onDisplayPlanSelection(org?.get('id'), org.get('displayName')),
        );
        this.disableSubmit();
        return;
      }

      const isTargetWorkspaceReadOnly = isWorkspaceReadOnly(
        org?.get('offering'),
        org?.get('limits')?.orgs?.usersPerFreeOrg?.status,
      );

      if (org && isTargetWorkspaceReadOnly) {
        this.disableSubmit();
        this.renderReadOnlyWorkspaceUpsell(org);
        return;
      }

      this.renderBoardVisChooser();
      this.renderCustomFieldsWarning(org);
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loadOrg(orgId: any) {
    return Bluebird.try(() => {
      if (orgId) {
        const org = ModelCache.get('Organization', orgId);
        // see if the org exists in the cache and contains all the data that we need
        // otherwise, go ahead and get the info from the api.
        if (
          org?.get('memberships') &&
          org?.get('prefs') &&
          org?.get('offering') &&
          org?.get('limits')
        ) {
          return org;
        } else {
          return ModelLoader.loadOrganizationMinimalWithoutBoards(orgId);
        }
      } else {
        return null;
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderBoardVisChooser(selectedVis?: any) {
    $('.js-permissions', this.$el).removeClass('hide');
    const orgId = $('select[name="org-id"]', this.$el).val();

    const visData = {
      isNewBoard: true,
      canChange: true,
    };

    this.disableSubmit();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const localizedParagraph = (key: any) => `<p>${l(key)}</p>`;
    $('.js-vis-display', this.$el).html(
      localizedParagraph('checking visibility permissions'),
    );

    this.loadOrg(orgId)
      .then((org) => {
        if (org != null) {
          const enterprise = org != null ? org.getEnterprise() : undefined;
          if (!this.canChangeOrg(org, selectedVis)) {
            selectedVis = null;
          }

          Object.assign(visData, {
            hasOrg: true,
            orgName: org.get('displayName'),
            hasSuperAdmins: org.isFeatureEnabled('superAdmins'),
            privateRestricted: !this.canChangeOrg(org, 'private'),
            orgRestricted: !this.canChangeOrg(org, 'org'),
            enterpriseRestricted: !this.canChangeOrg(org, 'enterprise'),
            publicRestricted: !this.canChangeOrg(org, 'public'),
            hasEnterprise:
              org != null ? org.belongsToRealEnterprise() : undefined,
            enterpriseName: enterprise?.get?.('displayName'),
            isTemplate: this.model.isTemplate(),
            isPaidOrg: org?.hasPaidProduct(),
          });
        } else if (Auth.me().isPaidManagedEntMember()) {
          const enterprise = Auth.me().getEnterprise();
          if (enterprise) {
            if (!enterprise.canSetTeamlessBoardVisibility(selectedVis)) {
              selectedVis = null;
            }
            Object.assign(visData, {
              hasOrg: false,
              hasSuperAdmins: false,
              privateRestricted:
                !enterprise.canSetTeamlessBoardVisibility('private'),
              orgRestricted: true,
              enterpriseRestricted: true,
              publicRestricted:
                !enterprise.canSetTeamlessBoardVisibility('public'),
              hasEnterprise: true,
              enterpriseName: enterprise.get('displayName'),
              isTemplate: this.model.isTemplate(),
              isPaidOrg: false,
              isTeamlessOwnedBoard: true,
            });
          }
        }

        const defaultVis =
          org != null && this.canChangeOrg(org, 'org')
            ? this.model.isPrivate() && this.canChangeOrg(org, 'private')
              ? 'private'
              : 'org'
            : // @ts-expect-error TS(2339): Property 'isTeamlessOwnedBoard' does not exist on ... Remove this comment to see the full error message
              visData.isTeamlessOwnedBoard &&
                // @ts-expect-error TS(2339): Property 'privateRestricted' does not exist on typ... Remove this comment to see the full error message
                visData.privateRestricted &&
                // @ts-expect-error TS(2339): Property 'publicRestricted' does not exist on type... Remove this comment to see the full error message
                !visData.publicRestricted
              ? 'public'
              : 'private';
        // @ts-expect-error TS(2339): Property 'current' does not exist on type '{ isNew... Remove this comment to see the full error message
        visData.current = selectedVis != null ? selectedVis : defaultVis;

        return { org, visData };
      })

      // eslint-disable-next-line @typescript-eslint/no-shadow
      .then(({ org, visData }) => {
        // It's possible that there's no valid permission level for us, in which
        // case we can't create a board at all
        let noValidPrivs = false;
        if (
          // @ts-expect-error TS(2339): Property 'privateRestricted' does not exist on typ... Remove this comment to see the full error message
          visData.privateRestricted &&
          // @ts-expect-error TS(2339): Property 'orgRestricted' does not exist on type '{... Remove this comment to see the full error message
          visData.orgRestricted &&
          // @ts-expect-error TS(2339): Property 'enterpriseRestricted' does not exist on ... Remove this comment to see the full error message
          visData.enterpriseRestricted &&
          // @ts-expect-error TS(2339): Property 'publicRestricted' does not exist on type... Remove this comment to see the full error message
          visData.publicRestricted
        ) {
          noValidPrivs = true;

          const $noValidPrivs = $('.js-no-valid-org-privs', this.$el);
          if (org?.owned()) {
            $noValidPrivs.html(
              l('board create restriction admin', {
                urlSettings: getOrganizationAccountUrl(org.get('name')),
              }),
            );
            // @ts-expect-error TS(2339): Property 'isTeamlessOwnedBoard' does not exist on ... Remove this comment to see the full error message
          } else if (visData.isTeamlessOwnedBoard) {
            $noValidPrivs.html(l('board create restriction enterprise'));
          } else {
            $noValidPrivs.html(l('board create restriction not admin'));
          }
          $noValidPrivs.removeClass('hide');
          $('.js-vis-chooser,.js-vis-display', this.$el).addClass('hide');
        }

        $('.js-vis-chooser', this.$el).html(BoardMenuVisTemplate(visData));

        const previousLevel = this.getPermissionLevel();
        // @ts-expect-error TS(2339): Property 'current' does not exist on type '{ isNew... Remove this comment to see the full error message
        const currentLevel = visData.current;

        // Only show confirmation if changing visibility to public
        if (previousLevel !== currentLevel && currentLevel === 'public') {
          return this.openPublicConfirmation();
        } else {
          this.setPermissionLevel(currentLevel);
          this.renderVisDisplay(currentLevel);
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          const isTrimmedInputHasText = $('input[id="boardNewTitle"]', this.$el)
            .val()
            // @ts-expect-error TS(2339): Property 'trim' does not exist on type 'string | n... Remove this comment to see the full error message
            .trim();
          const isCreateButtonEnabled = !$('.js-submit', this.$el).hasClass(
            'disabled',
          );
          if (
            !noValidPrivs &&
            isTrimmedInputHasText &&
            !isCreateButtonEnabled
          ) {
            this.enableSubmit();
          }
        }
      });

    return this;
  }

  enableSubmit() {
    return $('.js-submit', this.$el).removeClass('disabled');
  }

  disableSubmit() {
    return $('.js-submit', this.$el).addClass('disabled');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderVisDisplay(vis: any) {
    return $('.js-vis-display', this.$el).html(
      templates.fill(BoardCopyVisTemplate, {
        visIconClass: getPermLevelIconClass(vis),
        visDisplayText: l(['board perms', vis, 'name']),
      }),
    );
  }

  resetVisChooser() {
    $('.js-no-valid-org-privs', this.$el).addClass('hide');
  }

  openPublicConfirmation() {
    $('.js-vis-display', this.$el).addClass('hide');
    return $('.js-confirm-public-message', this.$el).removeClass('hide');
  }

  hidePublicConfirmation() {
    $('.js-confirm-public-message', this.$el).addClass('hide');
    return $('.js-vis-display', this.$el).removeClass('hide');
  }

  confirmPublic() {
    Analytics.sendUpdatedBoardFieldEvent({
      field: 'visibility',
      value: 'public',
      source: 'copyBoardInlineDialog',
      containers: {
        board: {
          id: this.model.id,
        },
        organization: {
          id: this.model.getOrganization()?.id,
        },
      },
      attributes: {
        previous: this.model.getPermLevel(),
        change: this.model.getPermLevel() !== 'public',
        isTemplate: this.model.isTemplate(),
      },
    });

    this.setPermissionLevel('public');
    this.renderVisDisplay('public');
    this.hidePublicConfirmation();
    this.enableSubmit();
  }

  cancelPublic() {
    const previousPermissionLevel = this.getPermissionLevel();
    this.renderBoardVisChooser(previousPermissionLevel);
    this.hidePublicConfirmation();

    return Analytics.sendTrackEvent({
      action: 'cancelled',
      actionSubject: 'visibility',
      source: 'copyBoardInlineDialog',
      attributes: {
        visibility: 'public',
      },
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openChangeVis(e: any) {
    stopPropagationAndPreventDefault(e);
    $('.js-vis-display', this.$el).addClass('hide');
    $('.js-vis-chooser', this.$el).removeClass('hide');
    $('.js-confirm-public-message', this.$el).addClass('hide');
  }

  onBoardNameChangeDebounced(e: HTMLInputElement) {
    this._onBoardNameChangeDebounced(e);
  }

  onBoardNameChange(e: HTMLInputElement) {
    const idOrganization = $('select[name="org-id"]', this.$el).val();

    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    const isTrimmedInputHasText = $(e.target).val().trim();
    const isCreateButtonEnabled = !$('.js-submit', this.$el).hasClass(
      'disabled',
    );

    if (isTrimmedInputHasText && !isCreateButtonEnabled) {
      this.loadOrg(idOrganization).then((org) => {
        if (org?.isAtOrOverFreeBoardLimit()) {
          return;
        }

        if (
          isWorkspaceReadOnly(
            org?.get('offering'),
            org?.get('limits')?.orgs?.usersPerFreeOrg?.status,
          )
        ) {
          return;
        }

        this.enableSubmit();
      });

      return;
    }

    if (!isTrimmedInputHasText && isCreateButtonEnabled) {
      this.disableSubmit();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectVis(e: any) {
    stopPropagationAndPreventDefault(e);

    const $target = $(e.target).closest('.js-select');
    if ($target.hasClass('disabled')) {
      return;
    }

    $('.js-vis-display', this.$el).removeClass('hide');
    $('.js-vis-chooser', this.$el).addClass('hide');

    const originalVis = this.getPermissionLevel();
    const vis = $target.attr('name');
    this.renderBoardVisChooser(vis);

    Analytics.sendUpdatedBoardFieldEvent({
      field: 'visibility',
      value: vis,
      source: 'copyBoardInlineDialog',
      containers: {
        board: {
          id: this.model.id,
        },
        organization: {
          id: this.model.getOrganization()?.id,
        },
      },
      attributes: {
        previous: originalVis,
        change: originalVis !== vis,
        isTemplate: this.model.isTemplate(),
      },
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setPermissionLevel(permissionLevel: any) {
    return $('input[name="permissionLevel"]', this.$el).val(permissionLevel);
  }

  getPermissionLevel() {
    let left;
    return (left = $('input[name="permissionLevel"]', this.$el).val()) != null
      ? left
      : '';
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  canChangeOrg(org: any, setting: any) {
    return org.canSetVisibility(setting);
  }

  allowBoardCopy() {
    $('.js-board-limits-upgrade-ad', this.$el).addClass('hide');
    this.resetVisChooser();
    $('.js-vis-display', this.$el).removeClass('hide');
    $('.js-vis-chooser', this.$el).addClass('hide');
    return this.renderBoardVisChooser();
  }

  // Open Free trial or BC Plan Selection
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDisplayPlanSelection(orgId: any, teamName: any) {
    const container = this.el.querySelector(
      '.copy-board-upsell-react-component',
    );

    if (!orgId || !container) {
      return;
    }

    renderReactRoot(
      <ComponentWrapper>
        <CreateBoardPopoverButton
          workspaceId={orgId}
          workspaceName={teamName}
          analyticsSource="copyBoardInlineDialog"
        />
      </ComponentWrapper>,
      container,
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  changeOrg(e: any) {
    $('.js-submit', this.$el).removeClass('hide');

    const orgId = e.target.value;

    Analytics.sendUpdatedBoardFieldEvent({
      field: 'organization',
      source: 'copyBoardInlineDialog',
      containers: {
        board: {
          id: this.model.id,
        },
        organization: {
          id: orgId,
        },
      }, // new organization
      attributes: {
        previous: this.model.getOrganization()?.id,
        change: this.model.getOrganization()?.id !== orgId,
        isTemplate: this.model.isTemplate(),
      },
    });

    this.hidePublicConfirmation();

    // personal boards have no restrictions
    if (!orgId) {
      this.allowBoardCopy();
      return;
    }

    // Use the permission check as a loading state when checking
    // the board limit
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const localizedParagraph = (key: any) => `<p>${l(key)}</p>`;
    $('.js-vis-display', this.$el).html(
      localizedParagraph('checking visibility permissions'),
    );

    // Hide any existing CTAs while we determine if the new ones are necessary
    $('.js-board-limits-upgrade-ad', this.$el).addClass('hide');
    $('.js-custom-fields-disabled-warning', this.$el).addClass('hide');
    this.unmountReadonlyWorkspaceUpsell?.();

    this.disableSubmit();
    return this.loadOrg(orgId).then((org) => {
      // Show the board limits CTA
      if (org?.isAtOrOverFreeBoardLimit()) {
        $('.js-permissions', this.$el).addClass('hide');
        $('.js-board-limits-upgrade-ad', this.$el).removeClass('hide');
        $('.js-target-team', this.$el).text(org.get('displayName'));
        $('.js-upgrade-link', this.$el).attr(
          'href',
          // @ts-expect-error TS(2345): Argument of type 'void' is not assignable to param... Remove this comment to see the full error message
          this.onDisplayPlanSelection(org?.get('id'), org.get('displayName')),
        );
        return;
      }

      const isTargetWorkspaceReadOnly = isWorkspaceReadOnly(
        org?.get('offering'),
        org?.get('limits')?.orgs?.usersPerFreeOrg?.status,
      );

      if (org && isTargetWorkspaceReadOnly) {
        this.renderReadOnlyWorkspaceUpsell(org);
        return;
      }

      this.renderCustomFieldsWarning(org);
      this.allowBoardCopy();
    });
  }

  // show a warning that custom fields wont be enabled on the copy if applicable
  renderCustomFieldsWarning(org: Organization | null) {
    const customFieldsWarning = $(
      '.js-custom-fields-disabled-warning',
      this.$el,
    );
    if (!customFieldsWarning || !org) {
      return;
    }

    if (
      !org.isFeatureEnabled('paidCorePlugins') &&
      this.model.isCustomFieldsEnabled()
    ) {
      customFieldsWarning.removeClass('hide');
      customFieldsWarning.html(
        format('upgrade-workspace-to-use-custom-fields', {
          name: org.get('name'),
          displayName: org.get('displayName'),
        }),
      );
    } else {
      customFieldsWarning.addClass('hide');
    }
  }

  defaultBackgroundColor() {
    if (usesEnglish()) {
      const now = new Date();
      const month = now.getMonth();
      const date = now.getDate();

      if (month === 2 && date === 17) {
        // It's March 17th, St. Patricks Day
        return 'green';
      }
    }

    return 'blue';
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  submit(e: any) {
    let left;
    stopPropagationAndPreventDefault(e);

    if ($('.js-submit', this.$el).hasClass('disabled')) {
      return;
    }

    // Figure out the name they want, and abort if it's blank

    const $name = $('input[name="name"]', this.$el);
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    const name = $name.val().trim();
    if (name === '') {
      $name.focus().select();
      return;
    }

    const eventSource = this.gasSource || 'copyBoardInlineDialog';
    const taskName = 'create-board/copy';
    const traceId = Analytics.startTask({
      taskName,
      source: eventSource,
    });
    Analytics.sendClickedButtonEvent({
      // @ts-expect-error TS(2322): Type '"createButton"' is not assignable to type 'A... Remove this comment to see the full error message
      buttonName: 'createButton',
      source: this.gasSource || 'copyBoardInlineDialog',
      attributes: {
        isTemplate: this.model.isTemplate(),
        taskId: traceId,
      },
    });

    const idOrganization =
      (left = $('select[name="org-id"]', this.$el).val()) != null ? left : '';

    // @ts-expect-error TS(2345): Argument of type 'string | number | string[]' is n... Remove this comment to see the full error message
    LastOrganization.set(idOrganization);

    // Data that we'll use in the body of the POST to create the board
    const initialData = {
      name,
      idOrganization,
    };

    const permissionLevel = $('input[name="permissionLevel"]', this.$el).val();

    // Data that we're going to send in the create request; not all of the
    // fields will be board attributes
    let requestData = {
      prefs_permissionLevel: permissionLevel,
      ...initialData,
    };

    if (this.model.isTemplate()) {
      requestData = {
        // @ts-expect-error TS(2322): Type '{ name: any; idOrganization: string | number... Remove this comment to see the full error message
        prefs_isTemplate: false,
        ...requestData,
      };
    }

    // @ts-expect-error TS(2339): Property 'idBoardSource' does not exist on type '{... Remove this comment to see the full error message
    requestData.idBoardSource = this.model.id;
    // @ts-expect-error TS(2339): Property 'keepFromSource' does not exist on type '... Remove this comment to see the full error message
    requestData.keepFromSource = $('input:checkbox:checked', this.$el)
      .map(function () {
        // @ts-expect-error TS(2339): Property 'name' does not exist on type 'HTMLElemen... Remove this comment to see the full error message
        return this.name;
      })
      .get()
      .join();

    Auth.me().boardList.createWithTracing(initialData, {
      // @ts-expect-error
      modelCache: this.modelCache,
      requestData,
      traceId,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      success: (board: any) => {
        let currentBoards, needle;
        Alerts.hide('copy-board');
        Alerts.hide('templates');

        Analytics.sendCopiedBoardEvent({
          source: eventSource,
          containers: {
            board: {
              id: board.id,
            },
            organization: {
              // @ts-expect-error TS(2322): Type 'string | number | string[]' is not assignabl... Remove this comment to see the full error message
              id: idOrganization,
            },
          },
          attributes: {
            sourceBoardId: this.model.id,
            fromTemplate: this.model.isTemplate(),
            templateCategory: this.model.get('templateGallery')?.category,
            visibility: board.getPermLevel(),
            isBCFeature: true,
            requiredBC: false,
            taskId: traceId,
          },
        });

        Analytics.taskSucceeded({
          taskName,
          traceId,
          source: eventSource,
        });

        // this fixes an issue with idBoards not being updated at the time that
        // the board gets rendered and the client thinking the member is not on
        // the board
        if (
          ((needle = board.id),
          !Array.from((currentBoards = Auth.me().get('idBoards'))).includes(
            needle,
          ))
        ) {
          Auth.me().set('idBoards', currentBoards.concat(board.id));
        }

        if (isEmbeddedInAtlassian()) {
          window.open(getBoardUrl(board.id), '_blank');
        } else {
          const relativeBoardUrl = new URL(board.attributes.url).pathname;
          navigate(relativeBoardUrl, {
            trigger: true,
          });
        }
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      error: (model: any, error: any, xhrResponse: any) => {
        const textStatus = xhrResponse.responseText;
        if (/ENTERPRISE_OWNED_ENTITY/.test(textStatus)) {
          Analytics.taskFailed({
            taskName,
            traceId,
            source: eventSource,
            error,
          });
          Alerts.hide('copy-board');
          return Alerts.show(
            [
              'unlicensed member cannot copy enterprise board',
              {
                enterpriseName: this.model.getEnterprise()?.get('displayName'),
              },
            ],
            'error',
            'copy-board',
            7000,
          );
        } else if (
          /SOURCE_TEMPLATE_CONTAINS_FORBIDDEN_ENTERPRISE_POWER_UPS/.test(
            textStatus,
          )
        ) {
          Analytics.taskFailed({
            taskName,
            traceId,
            source: eventSource,
            error,
          });
          const powerUpsNames =
            this.parseTemplateContainsForbiddenPowerUpsError(textStatus);

          Alerts.hide('templates');
          return Alerts.show(
            [
              'source template contains forbidden enterprise power ups',
              { powerUps: powerUpsNames },
            ],
            'error',
            'forbiddenPowerUps',
            7000,
          );
        } else {
          Analytics.taskFailed({
            taskName,
            traceId,
            source: eventSource,
            error,
          });

          return Alerts.flash('could not create board', 'error', 'copy-board');
        }
      },
    });

    if (this.model.isTemplate()) {
      Alerts.show('creating-board', 'info', 'templates');
    } else {
      Alerts.show('copying', 'info', 'copy-board');
    }

    return PopOver.hide();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  parseTemplateContainsForbiddenPowerUpsError(errorStatusText: any) {
    const { message } = JSON.parse(errorStatusText);
    const forbiddenPowerUpsNames = message.slice(1 + message.indexOf(':'));

    return forbiddenPowerUpsNames.trimLeft();
  }

  renderReadOnlyWorkspaceUpsell(targetWorkspace: Organization) {
    $('.js-submit', this.$el).addClass('hide');
    $('.js-permissions', this.$el).addClass('hide');

    const targetWorkspaceId = targetWorkspace.get('id');

    // Let's re-evaluate if the move is allowed as a result of the workspace
    // offering changing due to the user signing up for Premium via the upsell.
    this.listenToOnce(targetWorkspace, 'change:offering', () => {
      this.changeOrg({
        target: { value: targetWorkspaceId },
      });
    });

    const { unmount } = renderReactRoot(
      <ComponentWrapper>
        <BoardWouldPushWorkspaceOverLimit
          workspaceId={targetWorkspaceId}
          action="copy"
        />
      </ComponentWrapper>,
      $('.js-read-only-workspace-upsell', this.$el)[0],
    );

    this.unmountReadonlyWorkspaceUpsell = () => {
      unmount();
      // Just in case the user selects a different workspace without first signing up for Premium
      // via the upsell.
      this.stopListening(targetWorkspace, 'change:offering');
    };
  }

  remove() {
    this.unmountReadonlyWorkspaceUpsell?.();
    return super.remove(...arguments);
  }
}

CopyBoardView.initClass();
export { CopyBoardView };
